import CallToAction from './CallToAction';
import BladeController from './BladeController';
import InlineLink from './InlineLink';
import ModalTrigger from './ModalTrigger';

interface ActionControllerProps {
  className?: string;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  data: any;
}

const ActionController = ({ className, data }: ActionControllerProps) => {
  switch (data?.internal?.type) {
    case 'ContentfulBlade':
      return (
        <BladeController key={data.id} className={className} data={data} />
      );
    case 'ContentfulLinkWrapper':
      return (
        <InlineLink key={data.id} className={className} href={data.linkUrl}>
          {data.linkText}
        </InlineLink>
      );
    case 'ContentfulButton':
      return (
        <CallToAction
          key={data.id}
          className={className}
          variant={data.buttonType}
          href={data.buttonUrl}
        >
          {data.buttonLabel}
        </CallToAction>
      );
    case 'ContentfulModal':
      return (
        <ModalTrigger
          data={data}
          key={data.id}
        />
      );
    default:
      return null;
  }
};

export default ActionController;
